import { Flower2, Package } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { LanguageSelector } from "@/components/LanguageSelector";
import { InstallPWA } from "@/components/InstallPWA";

// Header Component
export const Header = () => {
  const { t } = useLanguage();

  return (
    <header className="py-6 md:py-8 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div
              className="w-12 h-12 rounded-full flex items-center justify-center"
              style={{ backgroundColor: 'rgba(163, 177, 138, 0.2)' }}
            >
              <Flower2 className="w-6 h-6" style={{ color: '#1A3C34' }} />
            </div>
            <div>
              <h1 className="font-heading text-2xl md:text-3xl" style={{ color: '#1A3C34' }}>
                {t.appName}
              </h1>
              <p className="font-accent text-sm" style={{ color: '#6B705C' }}>
                {t.appTagline}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <LanguageSelector />
            <InstallPWA t={t} variant="button" />
            <a
              href="https://www.floralife.mx/productos-para-flores"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:flex items-center gap-2 px-4 py-2 rounded-full transition-all hover:scale-105"
              style={{ backgroundColor: 'rgba(163, 177, 138, 0.2)', color: '#1A3C34' }}
            >
              <Package className="w-4 h-4" />
              <span className="font-body text-sm">{t.viewAllProducts}</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};
